<template>
  <div>
    <AddDataInline
      v-if="!readonly"
      :bp="bp"
      @submit="new_data_inline"
    />
    <DraggableTabs
      :current_tab="tab"
      :data="data"
      :is_mobile="is_mobile"
      :sortable="!readonly"
      :readonly="readonly"
      @change_tab="change_tab"
      @update="update_tabs"
    >
      <template v-slot:add>
        <div>
          <AddInline
            v-if="!readonly"
            :bp="bp"
            @submit="(value) => {update((data || []).length,value)}"
          />
        </div>
      </template>
    </DraggableTabs>

    <!-- Tabs content -->
    <v-tabs-items
      v-model="tab"
      touchless
    >
      <v-tab-item
        v-for="(inlines,index) in data"
        :key="index"
      >
        <div class="transition">
          <div class="d-flex">
          <AddInline
            v-if="!readonly"
            :field="inlines"
            custom_icon="mdi-pencil"
            :bp="bp"
            @submit="(value) => {update(index,value)}"
          />
            <v-btn @click="toggle_data_view" icon><v-icon>{{view_data ? 'mdi-eye-off-outline' : 'mdi-eye-outline'}}</v-icon></v-btn>
          </div>
            <Input
              v-if="view_data"
              :value="inlines"
              :readonly="readonly"
              :roles="roles"
              @update="(value) => {update(index,value)}"
            />
          <InlineInput
            :raw_fields="inlines"
            :parsed_fields="(bp._parsed_inlines || [])[index]"
            :json="bp"
            :readonly="readonly"
            :lang="lang"
            :is_mobile="is_mobile"
            @update="(value) => {update(index,value)}"
            />
          </div>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>
    
<script>
  import InlineInput from '@/components/bpcreator/inputs/InlineInput';
  import Input from '@/components/bpcreator/inputs/Input';
  import AddDataInline from '@/components/bpcreator/model/AddDataInline';
  import AddInline from '@/components/bpcreator/model/AddInline';
  import DraggableTabs from '@/components/bpcreator/inputs/inlines/DraggableTabs';
  export default {
    components: {
      InlineInput,
      Input,
      AddDataInline,
      DraggableTabs,
      AddInline,
    },
        
    name: 'Inlines',
        
    props: {
      bp: {default: () => ({})},
      data: {default: () => ({})},
      readonly: Boolean,
      is_mobile: Boolean,
      lang: String,
      roles: {default: ()=>({})},
    },
        
    data: () => ({
      tab: 0,
      view_data: false,
    }),
        
    computed: {
    },
        
    mounted() {
    },
        
    methods: {
      change_tab(tab) {
        this.tab = tab;
      },

      update_tabs(tabs) {
        this.$emit('update', tabs);
      },

      update(index,value) {
        let new_item = [...this.data];
        if (index < this.data.length) {
          new_item[index] = value;
        } else {
          new_item.push(value);
        }
        this.$emit('update', new_item);
      },

      new_data_inline(inline,tab) {
        const tab_index = tab >= 0 ? tab : this.data.length; 
        this.update(tab_index,inline);
      },

      new_inline(inline) {
        this.update(this.data.length,inline);
      },

      toggle_data_view() {
        this.view_data = !this.view_data;
      },
    },
    
    watch: {
    },
  }
</script>